export const getParameterValue = (key: string): string => {
  if (!key) return ''
  const search = window.location.search || ''
  const params = new URLSearchParams(search)
  return params.get(key) || ''
}

